

const MobileWidgets = () => {
  return (
    <div className="offcanvas-widget-area">
      <div className="off-canvas-contact-widget">
        <div className="header-contact-info">
          <ul className="header-contact-info__list">
            <li>
              <i className="fa fa-phone"></i>{" "}
              <a href="tel://085161316022">0851-6131-6022</a>
            </li>
            <li>
              <i className="fa fa-envelope"></i>{" "}
              <a href="mailto:thekeeus@gmail.com">thekeeus@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="off-canvas-widget-social">
        <a href="https://www.instagram.com/keeus.id" title="Instagram">
          <i className="fa fa-instagram"></i>
        </a>
        <a href="https://wa.me/6285161316022?text=Halo%20Keeus,%20Saya%20mau%20tanya%20tanya" title="WhatsApp">
          <i className="fa fa-whatsapp"></i>
        </a>
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
